import React from "react";
import {format} from "date-fns";

const BatchDesktopView = ({
	                          batches,
	                          expandedBatchId,
	                          toggleExpand,
	                          renderStatusBadge,
	                          calculateBatchQuantities,
	                          renderActionButtons,
	                          handleAllocateMaterials,
	                          navigate,
	                          processingAction,
	                          setDeleteBatchId,
	                          setShowDeleteModal
                          }) => (
	<div className="overflow-x-auto">
		<table className="min-w-full divide-y divide-gray-200">
			<thead className="bg-gray-50">
			<tr>
				<th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Batch Number</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created By</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Planned Qty</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Completed</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Planned Completion</th>
				<th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
			</tr>
			</thead>
			<tbody className="bg-white divide-y divide-gray-200">
			{batches.map((batch) => {
				const quantities = calculateBatchQuantities(batch);
				const isExpanded = expandedBatchId === batch.id;

				return (
					<React.Fragment key={batch.id}>
						{/* Main batch row */}
						<tr className={`hover:bg-gray-50 cursor-pointer ${isExpanded ? 'bg-blue-50' : ''}`} onClick={() => toggleExpand(batch.id)}>
							<td className="px-2 py-4 whitespace-nowrap text-sm text-gray-500">
								<button className="text-gray-500 hover:text-gray-700 focus:outline-none">
									<svg
										className={`h-5 w-5 transition-transform ${isExpanded ? 'transform rotate-90' : ''}`}
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
										fill="currentColor"
									>
										<path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/>
									</svg>
								</button>
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
								{batch.batch_number}
								<div className="mt-1 text-[10px] text-gray-600">
									{batch.items && batch.items.length > 0
									 ? batch.items.map((item) => (
											<p key={item.id + item.product.sku}>{item.product.sku}-{item.identifier} ({item.quantity})</p>
										))
									 : 'No items in batch'}
								</div>
							</td>
							<td className="px-6 py-4 whitespace-nowrap">
								{batch?.user?.name}
							</td>
							<td className="px-6 py-4 whitespace-nowrap">
								{renderStatusBadge(batch.status)}
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
								{quantities.planned}
							</td>
							<td className="px-6 py-4 whitespace-nowrap">
								<div className="text-sm text-gray-500">
									{quantities.completed} / {quantities.planned}
								</div>
								<div className="w-full bg-gray-200 h-2 mt-1 rounded-full overflow-hidden">
									<div
										className="bg-blue-600 h-full rounded-full"
										style={{
											width: `${quantities.planned > 0 ? Math.min(100, Math.floor((quantities.completed / quantities.planned) * 100)) : 0}%`
										}}
									/>
								</div>
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
								{format(new Date(batch.planned_completion_date + 'T12:00:00'), 'MM/dd/yyyy')}
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
								<div className="flex justify-start space-x-2">
									{batch.status === 'planned' && (
										<button
											onClick={(e) => {
												e.stopPropagation();
												handleAllocateMaterials(batch.id);
											}}
											disabled={processingAction}
											className="px-2 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:opacity-50"
										>
											Allocate All Materials
										</button>
									)}
									<button
										onClick={(e) => {
											e.stopPropagation();
											navigate(`/production/${batch.id}`);
										}}
										className="text-blue-600 hover:text-blue-900"
									>
										<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
											<path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
											<path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
										</svg>
									</button>
									{batch.status !== 'completed' && (
										<button
											onClick={(e) => {
												e.stopPropagation();
												navigate(`/production/${batch.id}/edit`);
											}}
											className="text-gray-600 hover:text-gray-900"
										>
											<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
												<path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
											</svg>
										</button>
									)}
									<button
										onClick={(e) => {
											e.stopPropagation();
											setDeleteBatchId(batch.id);
											setShowDeleteModal(true);
										}}
										className="text-red-600 hover:text-red-900"
									>
										<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
											<path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd"/>
										</svg>
									</button>
								</div>
							</td>
						</tr>

						{/* Expanded items section */}
						{isExpanded && (
							<tr>
								<td colSpan="7" className="px-6 py-4 bg-gray-50">
									<div className="overflow-x-auto">
										<table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
											<thead className="bg-gray-100">
											<tr>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Completed</th>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Variant</th>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
												<th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
											</tr>
											</thead>
											<tbody className="bg-white divide-y divide-gray-200">
											{batch.items && batch.items.length > 0 ? (
												batch.items.map((item) => (
													<>
														<tr key={batch.id + '-' + item.id} className="hover:bg-gray-50">
															<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">
																{item.product?.sku || 'N/A'}-{item.identifier}
															</td>
															<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
																{item.quantity}
															</td>
															<td className="px-4 py-2 whitespace-nowrap">
																<div className="text-sm text-gray-500">
																	{item.completed_quantity || 0} / {item.quantity}
																</div>
																<div className="w-full bg-gray-200 h-2 mt-1 rounded-full overflow-hidden">
																	<div
																		className="bg-green-600 h-full rounded-full"
																		style={{
																			width: `${item.quantity > 0 ? Math.min(100, Math.floor(((item.completed_quantity || 0) / item.quantity) * 100)) : 0}%`
																		}}
																	/>
																</div>
															</td>
															<td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500">
																{item.variant || 'Standard'}
															</td>
															<td className="px-4 py-2 whitespace-nowrap">
																{renderStatusBadge(item.status, item.missing_parts)}
															</td>
															<td className="px-4 py-2 whitespace-nowrap">
																{renderActionButtons(batch, item, false)}
															</td>
														</tr>
														{item.missing_parts && item.missing_parts.length > 0 && (
															<>
																<tr className={`bg-red-50 border-red-100`}><td className={`text-red-600 font-bold pl-4`} colspan={6}>Missing Parts! Cannot produce this item with current inventory.</td></tr>
																<tr className={`bg-red-50 border-red-100`}>

																	<th className="text-left font-medium text-gray-700 pl-4" colspan={1}>Part</th>
																	<th className="text-right font-medium text-gray-700 pl-4" colspan={1}>Required</th>
																	<th className="text-right font-medium text-gray-700 pl-4" colspan={1}>Available</th>
																	<th className="text-right font-medium text-gray-700" colspan={1}>Shortage</th>
																	<th colspan={2}></th>
																</tr>

																{item.missing_parts.map((part, partIndex) => (
																	<tr key={partIndex} className={`bg-red-50 border-red-100`}>

																		<td className="pl-4" colspan={1}>{part.name}</td>
																		<td className="text-right pl-4" colspan={1}>{part.required}</td>
																		<td className="text-right pl-4" colspan={1}>{part.available_total}</td>
																		<td className="text-right font-medium text-red-600" colspan={1}>{part.shortage}</td>
																		<td colspan={2}></td>
																	</tr>
																))}
															</>
														)}
													</>
												))
											) : (
												 <tr>
													 <td colSpan="6" className="px-4 py-2 text-center text-sm text-gray-500">
														 No items in this batch
													 </td>
												 </tr>
											 )}


											</tbody>
										</table>

									</div>
								</td>
							</tr>
						)}
					</React.Fragment>
				);
			})}
			</tbody>
		</table>
	</div>
);

export default BatchDesktopView;
